import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const CategoryDiscountFields = ({ form, handleNestedChange, setForm }) => {
  const handleCollectionChange = (e) => {
    const value = e.target.value;
    setForm((prev) => ({
      ...prev,
      appliesTo: {
        ...prev.appliesTo,
        collectionTypes: typeof value === "string" ? value.split(",") : value,
      },
    }));
  };

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          select
          label="Target Collections"
          value={form.appliesTo?.collectionTypes || []}
          onChange={handleCollectionChange}
          SelectProps={{ multiple: true }}>
          <MenuItem value="standardCake">Standard Cakes</MenuItem>
          <MenuItem value="specialtyCake">Specialty Cakes</MenuItem>
          <MenuItem value="patisserie">Patisserie</MenuItem>
          <MenuItem value="grazeBox">Graze Boxes</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Discount Value"
          type="number"
          value={form.config.discountValue || ""}
          onChange={(e) =>
            handleNestedChange(
              "config",
              "discountValue",
              Number(e.target.value)
            )
          }
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          select
          label="Discount Type"
          value={form.config.discountType || "percentage"}
          onChange={(e) =>
            handleNestedChange("config", "discountType", e.target.value)
          }>
          <MenuItem value="percentage">%</MenuItem>
          <MenuItem value="fixed">$</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default CategoryDiscountFields;
